module.exports = __webpack_public_path__ + "img/DP001C_003.17e1c7e3.png";